import { Box, Button } from "@mui/material";

import { zodResolver } from "@hookform/resolvers/zod";
import { useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import * as z from "zod";

import { useCreateRuleRulesPostMutation } from "api";
import { SwitchInput } from "components/forms";
import { IRuleFallDetected } from "interfaces/rules.interface";

import { configurationSchema } from "../common/schemas";

const ruleFallDetectedSchema = z.object({
  configuration: configurationSchema,
});

type RuleFallDetectedSchema = z.infer<typeof ruleFallDetectedSchema>;

type RuleFallDetectedFormProps = {
  entityId: string;
  defaultValues: IRuleFallDetected | null;
  disabled: boolean;
  onClose: () => void;
};

export function RuleFallDetectedForm({
  entityId,
  defaultValues,
  disabled,
  onClose,
}: RuleFallDetectedFormProps) {
  const { t } = useTranslation();

  const [createRule] = useCreateRuleRulesPostMutation();

  const { control, handleSubmit } = useForm({
    defaultValues: ruleFallDetectedSchema.safeParse(defaultValues ?? {}).data,
    resolver: zodResolver(ruleFallDetectedSchema),
  });

  const onSubmit = async (data: RuleFallDetectedSchema) => {
    await createRule({
      ruleCreateModels: {
        ...data,
        type: "subject.fall-detected",
        entity_id: entityId,
        description: null,
        enabled: true,
      },
    });

    onClose();
  };

  return (
    <Box
      component={"form"}
      onSubmit={handleSubmit(onSubmit)}
      sx={{ display: "flex", flexDirection: "column", flexGrow: 1, gap: 2 }}
    >
      <SwitchInput
        control={control}
        disabled={disabled}
        fieldName={"configuration.execute_actions_on_alert_to_ok"}
        label={t("send_ok_message")}
      />
      <Box sx={{ flexGrow: 1 }} />
      {!disabled && <Button type={"submit"}>{t("Create")}</Button>}
    </Box>
  );
}
